import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoofIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0.75 12.2784L10 3L19.25 12.2784M13.2174 3.80682H15.6304C15.7371 3.80682 15.8394 3.84932 15.9148 3.92497C15.9902 4.00063 16.0326 4.10324 16.0326 4.21023V6.63068",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.5714 12H7.42857C7.19188 12 7 12.4477 7 13V17C7 17.5523 7.19188 18 7.42857 18H12.5714C12.8081 18 13 17.5523 13 17V13C13 12.4477 12.8081 12 12.5714 12Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgRoofIcon;
